import { colors } from "../../stitches.config";
import { StyledLink } from "../Common/__styles__/Typography";
import { BottomBanner } from "../Common/BottomBanner";
import { Body } from "../Common/Typography";

const GeolocateBanner = ({
  onClose,
  infoPanelOpen,
}: {
  onClose: () => void;
  infoPanelOpen: boolean;
}) => {
  return (
    <BottomBanner
      title={"Location permission"}
      subtitle={"Forerunner could not determine your precise location."}
      onClose={onClose}
      infoPanelOpen={infoPanelOpen}
    >
      <Body type="emphasis" size="default" color="contentInfoInverted">
        <StyledLink
          target="_blank"
          href="https://forerunner.helpscoutdocs.com/article/73-location-services"
          css={{ color: colors.contentInfoInverted }}
        >
          Get help
        </StyledLink>
      </Body>
    </BottomBanner>
  );
};

export default GeolocateBanner;
